import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { APIResults, AssemblyConfig } from "./sharedinterfaces";

export class DvsUtilities {
	static FlattenComponents(componenttree: APIResults.AssetComponentList): AssemblyConfig.ComponentBase[] {
		const results: AssemblyConfig.ComponentBase[] = [];
		for (const engine of componenttree.engine) {
			results.push(engine);
		}
		for (const tach of componenttree.tach) {
			results.push(tach);
		}
		// No trackers currently in AssetComponentList
		for (const shaft of componenttree.shaft) {
			results.push(shaft);
			for (const gear of shaft.gear) {
				results.push(gear);
			}
			for (const bearing of shaft.bearing) {
				results.push(bearing);
			}
			for (const motor of shaft.motor) {
				results.push(motor);
			}
		}
		for (const motorshaft of componenttree.motorshaft) {
			results.push(motorshaft);
			for (const motor of motorshaft.motor) {
				results.push(motor);
			}
			for (const motorbearing of motorshaft.bearing) {
				results.push(motorbearing);
			}
		}
		for (const impact of componenttree.impact) {
			results.push(impact);
		}
		for (const flutter of componenttree.flutter) {
			results.push(flutter);
		}
		for (const current of componenttree.current) {
			results.push(current);
		}
		for (const sensor of componenttree.sensor) {
			results.push(sensor);
		}
		return results;
	}

	static FeetToMeters(feet: number): number {
		return feet * 0.3048;
	}

	static AltitudeToTruncatedMeters(feet: number, baseElevationM: number): number {
		return Math.max(this.FeetToMeters(feet) - baseElevationM, 0);
	}

	static AddDegreeOffset(degrees: number, offset: number): number {
		if (!offset) return degrees;
		return (degrees + offset + 720.0) % 360.0;
	}

	static ReduceArray(array: any[], newLength: number, addLast = false) {
		if (newLength >= array.length) {
			return array.slice();
		}
		const factor = array.length / (array.length - newLength);
		const reduced = array.filter((e, i) => Math.floor(i % factor));
		// Add last element if requested
		if (addLast) {
			reduced.push(array[array.length - 1]);
		}
		return reduced;
	}

	static GetRemoteErrorMessage(err: any, fallback = false): string {
		if (err && err.error && err.error.message) return err.error.message;
		if (fallback && err && err.message) return err.message;
		return "";
	}

	static FormatNgbDate(date: NgbDateStruct, empty: string): string {
		return date ? date.year + "-" + date.month.toString().padStart(2, "0") + "-" + date.day.toString().padStart(2, "0") : empty;
	}
}
